// Shield and Hellish Rebuke, the two spells cast from a Reaction prompt. No imports, so the buff rules can read Shield's bonus.
export const SHIELD_FEATURE_ID = 'spell:shield';
export const HELLISH_REBUKE_FEATURE_ID = 'spell:hellish-rebuke';
export const HELLISH_REBUKE_TIEFLING_GRANT = 'tiefling-infernal-hellish-rebuke';
export const HELLISH_REBUKE_RANGE_FEET = 60;
export const SHIELD_AC_BONUS = 5;

/** Shield counts against the attack that triggered it, so the hit stands only if the roll still reaches the higher AC. */
export const shieldStopsAttack = ({ attackTotal, armorClass, critical }) => !critical
  && Number.isFinite(Number(attackTotal)) && Number.isFinite(Number(armorClass)) && Number(attackTotal) < Number(armorClass) + SHIELD_AC_BONUS;

export const createShieldEffect = ({ targetId, turnSequence, resolutionId }) => ({
  id: `shield:${resolutionId}`, definitionId: 'spell:shield', name: 'Shield', icon: '\u{1F6E1}', userVisible: true,
  sourceCombatantId: String(targetId), targetCombatantId: String(targetId), stackKey: `spell:shield:${targetId}`, stackPolicy: 'replace',
  appliedAtTurnSequence: turnSequence, removeOnSourceRemoval: false,
  expiration: { type: 'sourceTurn', combatantId: String(targetId), boundary: 'start', remainingOccurrences: 1 },
  duration: 'Until the start of your next turn', description: `+${SHIELD_AC_BONUS} to AC until the start of your next turn.`,
});

/** 2d10 Fire at level 1, and 1d10 more for each slot level above 1. */
export const hellishRebukeDiceCount = castLevel => Number(castLevel) + 1;
